export default __webpack_public_path__ + "static/media/select-char-background.d4874e3b.png";